import {
    CANVAS_ASSIGNMENT_META_FAILURE,
    CANVAS_ASSIGNMENT_META_REQUEST,
    CANVAS_ASSIGNMENT_META_SUCCESS,
} from './canvasAssignmentTypes'

const initialState = {
    loading: false,
    loadingMessage: '',
    fetchSuccess: false,
    assignmentData: [],
    message: '',
    error: '',
}

const reducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case CANVAS_ASSIGNMENT_META_REQUEST:
            return {
                ...state,
                loading: true,
                loadingMessage: 'Fetching assignment data...',
                fetchSuccess: false,
                assignmentData: {},
                message: '',
                error: '',
            }
        case CANVAS_ASSIGNMENT_META_SUCCESS:
            return {
                ...state,
                loading: false,
                loadingMessage: '',
                fetchSuccess: true,
                assignmentData: action.payload,
                message: '',
                error: '',
            }
        case CANVAS_ASSIGNMENT_META_FAILURE:
            return {
                ...state,
                loading: false,
                loadingMessage: '',
                fetchSuccess: false,
                assignmentData: {},
                message: '',
                error: action.payload,
            }
        default:
            return state
    }
}

export default reducer
